import { Navigate } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import EmailVerificationGuard from "./EmailVerificationGuard";

export default function RoleRoute({
  role,
  allowedRoles,
  children,
}: {
  role?: "student" | "instructor" | "admin" | "moderator";
  allowedRoles?: string[];
  children: JSX.Element;
}) {
  const { user, loading } = useAuthContext();

  if (loading) return <div className="p-4 text-center">กำลังโหลด...</div>;
  if (!user) return <Navigate to="/login" />;
  
  // Admin can access all routes
  const isAdmin = user.role === "admin";
  
  // Check if user has required role (skip for admin)
  if (!isAdmin) {
    if (role && user.role !== role) return <Navigate to="/" />;
    if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" />;
  }

  // Bypass email verification for admin role
  const bypassForAdmin = user.role === "admin";

  return (
    <EmailVerificationGuard bypassForAdmin={bypassForAdmin}>
      {children}
    </EmailVerificationGuard>
  );
}
